import { computed } from 'vue';
import { defineStore } from 'pinia';

import { logException } from '@apps/main/modules/plugins/logException';

import { getDomain, redirect, getCurrentOrigin } from '@libs/utils';

export const useCoreStore = defineStore('CoreStore', () => {
  function redirectToMainPage(): void {
    redirect(getCurrentOrigin());
  }

  function openSupportPage(): void {
    const supportPageUrl = getDomain.getCurrentDomainSpec().SupportPage;
    openInNewTab(supportPageUrl);
  }

  function openSembonusPage(): void {
    const url = `${getCurrentOrigin()}/sembonus`;
    openInNewTab(url);
  }

  function getTravelGuaranteePage(): string {
    const swedishGuaranteeUrl =
      'https://www.kammarkollegiet.se/vara-tjanster/resegaranti';
    const internationalGuaranteeUrl =
      'https://www.kammarkollegiet.se/engelska/start/all-services/travel-guarantees/sdg/information-about-travel-guarantees';
    const url =
      getDomain.getCurrentDomainSpec().Locale === 'sv'
        ? swedishGuaranteeUrl
        : internationalGuaranteeUrl;
    return url;
  }

  function openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  function handleImageLoadError(metadata: {
    src: string;
    source: string;
  }): void {
    logException(`Product card image failed loading from ${metadata.src}`, {
      src: metadata.src,
      source: metadata.source,
    });
  }

  // Getters
  const currentDomain = computed(() => getDomain.getCurrentDomainSpec().Domain);

  return {
    // Actions
    handleImageLoadError,
    openSupportPage,
    openInNewTab,
    redirectToMainPage,
    getTravelGuaranteePage,
    openSembonusPage,

    // Getters
    currentDomain,
  };
});
